import { render, staticRenderFns } from "./Ospiti.vue?vue&type=template&id=86431f38&"
import script from "./Ospiti.vue?vue&type=script&lang=ts&"
export * from "./Ospiti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports